import { mdiCheck, mdiClose, mdiAlertCircle, mdiCheckCircle } from '@mdi/js';
import Icon from '@mdi/react';
import { doc, updateDoc } from 'firebase/firestore';
import React, { useState } from 'react';
import { db } from '../../../firebase/firebase';
import { useAuth } from '../../../providers/AuthProvider';
import { ICollection } from '../../../types/Collections/collections';
import { collectionUrl } from '../../../lib/utils';

const CollectionAdminMakePublicModal = ({
  handleClose,
  collection: userCollection,
}: {
  handleClose: () => void;
  collection: ICollection;
}): JSX.Element => {
  const { uid } = useAuth();
  const [status, setStatus] = useState('idle');
  const [result, setResult] = useState<string | null>(null);

  const handleDelete = async () => {
    if (userCollection && userCollection.author?.uid && userCollection.id) {
      await updateDoc(
        doc(
          db,
          'userCollections',
          userCollection.author.uid,
          'collections',
          userCollection.id,
        ),
        {
          isPrivate: false,
          adminLockedPrivate: false,
          adminUnockedPublicUid: uid,
        },
      )
        .then(async () => {
          if (userCollection) {
            // Refresh the cache of the collection server-side
            await fetch(
              '/api/revalidate?secret=cmrne47ar7tc63xkucm23g5u9eh8jaaq',
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ url: collectionUrl(userCollection) }),
              },
            );
          }
          setStatus('success');
          setResult('Collection made public');
        })
        .catch(err => {
          setStatus('error');
          setResult(err.message);
        });
    } else {
      setStatus('error');
      setResult('Collection not found');
    }
  };

  if (status !== 'idle') {
    return (
      <div className="card confirm-dialog">
        <div className="card-content">
          <div
            className={
              status === 'error'
                ? 'has-text-danger has-text-centered'
                : 'has-text-success has-text-centered'
            }>
            <Icon
              path={status === 'error' ? mdiAlertCircle : mdiCheckCircle}
              size={3}
            />
          </div>
          <p className="has-text-centered is-font-brand-bold mb-4">{result}</p>
          <div className="buttons modal-footer-buttons">
            <button
              type="button"
              aria-label="Close"
              onClick={() => handleClose()}
              className="button is-light">
              <span>Close</span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card confirm-dialog">
      <div className="card-content">
        <p className="mb-4 is-font-brand is-size-4">
          Are you sure you wish to make this collection public?
        </p>
        <div className="buttons modal-footer-buttons">
          <button
            type="button"
            aria-label="Close"
            onClick={handleClose}
            className="button is-light is-medium">
            <span className="icon">
              <Icon path={mdiClose} size={1.25} />
            </span>
          </button>
          <button
            type="button"
            aria-label="OK"
            onClick={() => handleDelete()}
            className="button is-danger is-medium">
            <span className="icon">
              <Icon path={mdiCheck} size={1.25} />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CollectionAdminMakePublicModal;
